export default {"src":"https://fishbrain.com/_next/static/media/hawaii.a39953a8.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};